import { render } from "./AgentDetails.vue?vue&type=template&id=5e614ccb&scoped=true"
import script from "./AgentDetails.vue?vue&type=script&lang=js"
export * from "./AgentDetails.vue?vue&type=script&lang=js"

import "./AgentDetails.vue?vue&type=style&index=0&id=5e614ccb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e614ccb"]])

export default __exports__